import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({ page, pageSize, total, onPage, label = "înregistrări", testid = "pagination" }) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / pageSize));
  const from = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total || 0);
  return (
    <div className="flex items-center justify-between text-sm" data-testid={testid}>
      <span className="text-slate-500 tabular">
        {total || 0} {label}{total ? ` · ${from}–${to}` : ""}
      </span>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)} data-testid={`${testid}-prev`}><ChevronLeft className="h-4 w-4" /></Button>
        <span className="tabular">{page} / {totalPages}</span>
        <Button size="sm" variant="outline" disabled={page >= totalPages} onClick={() => onPage(page + 1)} data-testid={`${testid}-next`}><ChevronRight className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}
